import { Routes } from '@angular/router';
import { LoginPageComponent } from './features/login-page/login-page.component';
import { EventsComponent } from './features/events/events.component';
import { HeroReportComponent } from './features/hero-report/hero-report.component';
import { IncidentReportComponent } from './features/incident-report/incident-report.component';
import { UserManagementComponent } from './features/user-management/user-management.component';
import { OrganizationsComponent } from './features/organizations/organizations.component';
import { ConfigurationComponent } from './features/configuration/configuration.component';
import { AccountSettingsComponent } from './features/account-settings/account-settings.component';
import { RedirectComponent } from './features/redirect/redirect.component';
import { authGuard } from './auth.guard';
import { inverseAuthGuardGuard } from './inverse-auth-guard.guard';
import { HeroReportStepperComponent } from './features/hero-report-stepper/hero-report-stepper.component';
import { SreReportStepperComponent } from './features/sre-report/sre-report-stepper/sre-report-stepper.component';
import { IncidentReportStepperComponent } from './features/incident-report-stepper/incident-report-stepper.component';
import {accountResolver} from "./model/account/account.resolver";
import {regionResolver} from "./model/region/region.resolver";
import {organizationResolver} from "./model/organization/organization.resolver";
import {heroReportResolver} from "./model/hero-report/hero-report.resolver";
import {mapLayerResolver} from "./model/map-layer/map-layer.resolver";
import {heroReportByIdResolver} from "./model/hero-report/hero-report-by-id.resolver";
import { userAccountResolver } from './model/account/user-account.resolver';
import { NewPasswordComponent } from './features/new-password/new-password.component';
import { ForgotPasswordComponent } from './features/forgot-password/forgot-password.component';

export const routes: Routes = [
  {
    path: '',
    component: RedirectComponent
  },
  {
    path: 'login',
    component: LoginPageComponent,
    canActivate: [inverseAuthGuardGuard],
  },
  {
    path: 'new-password',
    component: NewPasswordComponent,
    canActivate: [inverseAuthGuardGuard],
  },
  {
    path: 'forgot-password',
    component: ForgotPasswordComponent,
    canActivate: [inverseAuthGuardGuard],
  },
  {
    path: 'events',
    component: EventsComponent,
    canActivate: [authGuard],
    resolve: {
      reports: heroReportResolver,
      mapLayers: mapLayerResolver,
      organizations: organizationResolver,
      regions: regionResolver,
      account: userAccountResolver
    }
  },
  {
    path: 'hero-report',
    component: HeroReportStepperComponent,
    canActivate: [authGuard],
  },
  {
    path: 'sre-report',
    component: SreReportStepperComponent,
    canActivate: [authGuard],
  },
  {
    path: 'hero-report/:id',
    component: HeroReportComponent,
    canActivate: [authGuard],
    resolve: {
      heroReport: heroReportByIdResolver
    }
  },
  {
    path: 'hero-report/:heroReportId/incident',
    component: IncidentReportStepperComponent,
    canActivate: [authGuard],
  },
  {
    path: 'hero-report/:heroReportId/incident/:id',
    component: IncidentReportComponent,
    canActivate: [authGuard],
  },
  {
    path: 'user-management',
    component: UserManagementComponent,
    canActivate: [authGuard],
    resolve: {
      accounts: accountResolver,
      regions: regionResolver,
      organizations: organizationResolver
    }
  },
  {
    path: 'organizations',
    component: OrganizationsComponent,
    canActivate: [authGuard],
    resolve: {
      regions: regionResolver,
      organizations: organizationResolver
    }
  },
  {
    path: 'configuration',
    component: ConfigurationComponent,
    canActivate: [authGuard],
  },
  {
    path: 'account-settings',
    component: AccountSettingsComponent,
    canActivate: [authGuard],
  },
];
